import AppSettings from 'Settings/AppSettings';
import ServiceWrapper from "Services/ServiceWrapper";
import AuthManager from "Common/AuthManager";
import {TPaginationParams} from "../../../Performance/analytics";
import {CustomCSSModel} from "../types/customcss.types";
import {UIModelTheme} from "../types/uimodel-theme.types";

const api_base_url = AppSettings.GMS_BACKEND_API_URL;

export const updateHeader = async (configureId: string, modelId: string, payload: any) => {
    try {
        let data = payload;

        if (!(payload instanceof FormData)) {
            const jsonString = JSON.stringify(payload);
            const parsedPayload = JSON.parse(jsonString);
            data = parsedPayload;
        }

        const response = await ServiceWrapper.doPut(
            `${api_base_url}/guide/${configureId}/model-ui/${modelId}/header`,
            data,
            null,
            AuthManager.getGmsToken(),
            true
        );
        return response?.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}

export const updateFooter = async (configureId: string, modelId: string, payload: any) => {
    try {
        let data = payload;

        if (!(payload instanceof FormData)) {
            const jsonString = JSON.stringify(payload);
            const parsedPayload = JSON.parse(jsonString);
            data = parsedPayload;
        }

        const response = await ServiceWrapper.doPut(
            `${api_base_url}/guide/${configureId}/model-ui/${modelId}/footer`,
            data,
            null,
            AuthManager.getGmsToken(),
            true
        );
        return response?.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}

export const updateNavigation = async (configureId: string, modelId: string, payload: any) => {
    const response = await ServiceWrapper.doPut(
        `${api_base_url}/guide/${configureId}/model-ui/${modelId}/navigation`,
        payload,
        null,
        AuthManager.getGmsToken(),
    );
    if (response?.errorfound) {
        const errMsg = (response.errorbj as any)?.message || 'Navigation save failed';
        throw new Error(errMsg);
    }
    return response?.data;
}

export const updateCanvas = async (configureId: string, modelId: string, canvasId: string, payload: any) => {
    try {
        const response = await ServiceWrapper.doPut(
            `${api_base_url}/guide/${configureId}/model-ui/${modelId}/canvas/${canvasId}`,
            payload,
            null,
            AuthManager.getGmsToken(),
        ); 
        return response?.data;
    } catch (error) {
        console.log(error);
    }
}

export const deleteCanvas = async (configureId: string, modelId: string, canvasId: string) => {
    try {
        const response = await ServiceWrapper.doDelete(
            `${api_base_url}/guide/${configureId}/model-ui/${modelId}/canvas/${canvasId}`,
            null,
            null,
            AuthManager.getGmsToken(),
        );
        return response?.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}

export const bulkDeleteCanvases = async (configureId: string, modelId: string, canvasIds: string[]) => {
    try {
        const response = await ServiceWrapper.doDelete(
            `${api_base_url}/guide/${configureId}/model-ui/${modelId}/canvas/bulk`,
            { canvasIds },
            null,
            AuthManager.getGmsToken(),
        );
        return response?.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}

export const getCanvas = async (configureId: string, modelId: string, canvasId: string) => {
    try {
        const response = await ServiceWrapper.doGet(
            `${api_base_url}/guide/${configureId}/model-ui/${modelId}/canvas/${canvasId}`,
            null,
            null,
            AuthManager.getGmsToken(),
        ); 
        return response?.data;
    }
    catch (error) {
        console.log(error);
    }
}

export const updateCss = async (configureId: string, modelId: string, payload: any) => {
    try {
        const response = await ServiceWrapper.doPut(
            `${api_base_url}/guide/${configureId}/model-ui/${modelId}/css`,
            payload,
            null,
            AuthManager.getGmsToken(),
    ); 
        return response?.data;
    } catch (error) {
        console.log(error);
    }
}

export const createUIModelApi = async (configureId: string, formData: FormData) => {
    try {
        const response = await ServiceWrapper.doPost(
            `${api_base_url}guide/${configureId}/model-ui`,
            formData,
            null,
            AuthManager.getGmsToken(),
            true
        );
        return response?.data;
    } catch (e) {
        console.log(e, "error");
        return null;
    }
}


export const updateUIModelApi = async (configureId: string, modelId: string, formData: FormData) => {
    try {
        const response = await ServiceWrapper.doPut(
            `${api_base_url}guide/${configureId}/model-ui/${modelId}`,
            formData,
            null,
            AuthManager.getGmsToken(),
            true
        );
        return response?.data;
    } catch (e) {
        console.log(e, "error");
        return null;
    }
}

export const copyUIModelApi = async (configureId: string, modelId: string, formData: FormData) => {
    try {
        const response = await ServiceWrapper.doPut(
            `${api_base_url}guide/${configureId}/model-ui/${modelId}/copy`,
            formData,
            null,
            AuthManager.getGmsToken(),
            true
        );
        return response?.data;
    } catch (e) {
        console.log(e, "error");
        return null;
    }
}

export const fetchUIModelsApi = async (projectId: string, paginationParams: TPaginationParams, sortBy: string, sortOrder: string, searchTerm: string) => {
    try {
        const response = await ServiceWrapper.doGet(
            `${api_base_url}guide/${projectId}/model-ui?page=${paginationParams.pageNumber}&limit=${paginationParams.pageSize}&sortBy=${sortBy}&sortOrder=${sortOrder}${searchTerm.length > 0 ? '&searchField=name&searchValue='+ searchTerm: ''}`,
            null,
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return null;
    }
}

export const deleteUIModelApi = async (configureId: string, uiModelId: string) => {
    try {
        const response = await ServiceWrapper.doPost(
            `${api_base_url}guide/${configureId}/model-ui/delete`,
            {uimodel_ids: [uiModelId]},
            null,
            AuthManager.getGmsToken()
        );
        return response?.data?.done;
    } catch (error) {
        console.log('Error', error);
        return null;
    }
}

export const getCustomCSS = async (projectId: string, modelId: string) => {
    try {
        const response = await ServiceWrapper.doGet(
            `${api_base_url}guide/${projectId}/model-ui/${modelId}/css`,
            null,
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return null;
    }
}

export const updateCustomCSS = async (projectId: string, modelId: string, data: CustomCSSModel | null) => {
    try {
        const response = await ServiceWrapper.doPut(
            `${api_base_url}guide/${projectId}/model-ui/${modelId}/css`,
            {customCss: data},
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return null;
    }
}

export const getUIModelById = async (configureId: string, modelId: string) => {
    try {
        const response = await ServiceWrapper.doGet(
            `${api_base_url}guide/${configureId}/model-ui/${modelId}`,
            null,
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return null;
    }
}

export const getProductsByCategory = async (industryId: string, categoryId: string) => {
    try {
        const response = await ServiceWrapper.doGet(
            `${api_base_url}guide/${industryId}/${categoryId}/products`,
            null,
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return null;
    }
}

export const getThemeAPI = async (projectId: string, modelId: string) => {
    try {
        const response = await ServiceWrapper.doGet(
            `${api_base_url}guide/${projectId}/model-ui/${modelId}/theme`,
            null,
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return null;
    }
}

export const updateThemeAPI = async (projectId: string, modelId: string, data: UIModelTheme | null) => {
    try {
        const response = await ServiceWrapper.doPut(
            `${api_base_url}guide/${projectId}/model-ui/${modelId}/theme`,
            {theme: data},
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return null;
    }
}

// Shared Widgets API - model-level widget configurations
export const getSharedWidgetsAPI = async (projectId: string, modelId: string) => {
    try {
        const response = await ServiceWrapper.doGet(
            `${api_base_url}guide/${projectId}/model-ui/${modelId}/shared-widgets`,
            null,
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (error) {
        console.log('Error fetching shared widgets:', error);
        return null;
    }
}

export const updateSharedWidgetsAPI = async (projectId: string, modelId: string, data: any) => {
    try {
        const body = data?.yourBuildWidget !== undefined ? data : { yourBuildWidget: data };
        const response = await ServiceWrapper.doPut(
            `${api_base_url}guide/${projectId}/model-ui/${modelId}/shared-widgets`,
            body,
            null,
            AuthManager.getGmsToken()
        );
        return response?.data;
    } catch (error) {
        console.log('Error updating shared widgets:', error);
        return null;
    }
}

export const imageIconUploadAPI = async (projectId: string, modelId: string, file: File, imageType: string = 'icon') => {
    try {
        const formData = new FormData();
        formData.append('imageType', imageType);
        formData.append('image', file);

        const response = await ServiceWrapper.doPost(
            `${api_base_url}guide/${projectId}/model-ui/${modelId}/upload-image`,
            formData,
            null,
            AuthManager.getGmsToken(),
            true
        );
        return response?.data;
    } catch (error) {
        console.log('Error', error);
        return null;
    }
}





